import React, { useContext, useState } from "react";
import AdminLoginForm from "../../../components/AdminComponents/adminLoginForm/AdminLoginForm";
import { AppContext } from "../../../context/app-context";
import { AuthService } from "../../../services/auth.service";
import AdminFooter from "../footer/AdminFooter";
import AdminHeader from "../header/AdminHeader";
import AdminMain from "../main/AdminMain";
import { SidebarAdmin } from "../sidebar/AdminSidebar";
import classes from "./AdminLayout.module.scss";

interface AdminLayoutProps {
  element?: React.ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ element }) => {
  const { isLoggedIn, AdminLoginHandler } = useContext(AppContext);
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [formType, setFormType] = useState("login");
  const [collapsed, setCollapsed] = useState(false);
  const [toggled, setToggled] = useState(false);

  const handleLogin = async (formData: { email: string; password: string }) => {
    console.log("formData (Layout): ", formData);
    AdminLoginHandler(JSON.stringify(formData));
    /* 
    try {
      const response = await AuthService.login({
        email: formData.email,
        password: formData.password,
      });
      if (response.statusCode === 200) {
        setFormType("admin");
      }
    } catch (error) {
      console.error("Login error:", error);
    }*/
  };

  const handleLogin2 = async (formData: {
    email: string;
    password: string;
  }) => {
    try {
      const response = await AuthService.login({
        email: formData.email,
        password: formData.password,
      });
      if (response.statusCode === 200) {
        setFormType("admin");
        console.log("başarılı");
      }
    } catch (error) {
      console.error("Login error:", error);
    }
  };

  if (!isLoggedIn) {
    return (
      <div className={classes.loginContainer}>
        <div className={classes.loginBox}>
          <div className={classes.loginLogo}>
            <img src="/assets/logo.png" alt="Logo" />
          </div>
          <AdminLoginForm
            formData={formData}
            setFormData={setFormData}
            setFormType={setFormType}
            submitHandler={handleLogin}
          />
        </div>
      </div>
    );
  }

  return (
    <div className={classes.adminLayout}>
      <AdminHeader
        collapsed={collapsed}
        toggled={toggled}
        setToggled={setToggled}
        setCollapsed={setCollapsed}
      />
      <div className={classes.adminLayoutContent}>
        <SidebarAdmin
          collapsed={collapsed}
          toggled={toggled}
          setToggled={setToggled}
          setCollapsed={setCollapsed}
        />
        {element && <AdminMain element={element} />}
      </div>
      <AdminFooter />
    </div>
  );
};

export default AdminLayout;
